<template>
  <div class="container">
    <img class="floor-button classroom-button" src="../assets/img/board_btn_b.png" alt="教室・部室棟"
         @click="moveToBuildingB">
    <img class="floor-button library-button" src="../assets/img/board_btn_a.png" alt="図書室・体育館・進路指導室"
         @click="moveToBuildingA">
  </div>
</template>

<script>
  export default {
    name: "Board",
    methods: {
      moveToBuildingA() {
        this.$router.push("/corridor/a11s");
        this.$emit("play-sound", "audio/vrschool_se_select.mp3");
      },
      moveToBuildingB() {
        this.$router.push("/corridor/b10e");
        this.$emit("play-sound", "audio/vrschool_se_select.mp3");
      }
    },
    mounted() {
      setTimeout(() => {
        this.$emit("play-sound", "audio/vrschool_wc_voice_003.mp3");
      }, 500);
    }
  }
</script>

<style scoped>

  .container {
    background: url("../assets/img/board_bg.png") no-repeat fixed center;
    background-size: contain;
  }

  .floor-button {
    cursor: pointer;
  }

  .classroom-button {
    position: absolute;
    left: 20%;
    top: 20%;
    width: 26.4%;
  }

  .library-button {
    display: block;
    position: absolute;
    right: 20%;
    top: 20%;
    width: 26.4%;
  }

</style>